const CONFIG = {
    API_BASE: "https://api.moatoverflow.com",
    API_URL: 'https://api.moatoverflow.com/v1',
    VOICE_BASE_URL: 'https://api.moatoverflow.com/voice',
    IMAGES_BASE_URL: 'https://api.moatoverflow.com/images',
}

export default CONFIG